import { Fragment, h } from 'preact';
import {iconCategoryButton, iconCategoryClose} from "../../../assets";
import s from "./mobileSidebar.module.css";
import {useMobileSidebar} from "./useMobileSidebar";

import {CategoriesFormTree} from "../../index";
import {MapFormatter} from "../../../utils";
import { useAppContext } from '../../../contexts';

const MobileSidebar = (props) => {
    // Destructured component props
    const {
        matches,
        data,
        shouldDisplayClearButton,
        handleClear,
        hiddenTitle,
        handleChange,
        selectedCategories,
        shouldFilter,
        collapseController,
        handleCollapseController,
        dispatchSyncEvent
    } = props;

    // Component logic data
    const componentProps = useMobileSidebar({
        data,
        selectedCategories
    });

    // Destructured component logic data
    const {
        isOpen,
        buttonLabel,
        handleMenu,
        handleClearFilters
    } = componentProps;

    const {highContrast} = useAppContext();

    // Validates whether the form should be rendered or not
    const form = matches ? (
        <CategoriesFormTree
            data={data}
            shouldDisplayClearButton={shouldDisplayClearButton}
            handleClear={handleClear}
            handleChange={handleChange}
            selectedCategories={selectedCategories}
            shouldFilter={shouldFilter}
            collapseController={collapseController}
            handleCollapseController={handleCollapseController}
        />
    ) : null;

    // The variable name already says it all
    const clearCategoriesButton = MapFormatter(selectedCategories).length > 0 ? (
        <button
            type={"button"}
            className={s.clearCategoriesButton}
            onClick={() => handleClearFilters()}
        >
            Limpar filtros
        </button>
    ) : null;

    // The initial call-to-action block
    const ctaBlock = (
        <div className={`flex md:hidden flex-col items-start justify-between mt-4 relative`}>
            <p className={`
                ${s.mobileSimpleTitle} 
                ${hiddenTitle ? " hidden" : ""} 
                ${highContrast ? "highTitleFirst" : ""}
            `}>{'Escolha nossos serviços'}</p>
            <button
                type={"button"}
                className={s.mobileButton}
                onClick={() => handleMenu()}
                data-testid="mobile-sidebar-menu-button"
            >
                <h4 className={s.buttonText}>
                    {buttonLabel}
                </h4>
                <div className={`${s.buttonIconContainer} ${highContrast ? "bg-contrast-yellow" : "bg-sabin-red-default"}`}>
                    <img
                        src={iconCategoryButton}
                        alt={"Category button icon"}
                        data-testid="mobile-sidebar-menu-image"
                        className={`${highContrast ? s.buttonIconHighContrast : s.buttonIcon}`}
                    />
                </div>
            </button>
            {clearCategoriesButton}
        </div>
    )

    return (
        <Fragment>
            {/* Button section */}
            {ctaBlock}

            {/* Sidebar and backdrop section */}
            <div className={"block md:hidden"}>
                <div
                    className={s.mobileCategoryMenuContainer + (isOpen ? ` ${s.isOpen}` : "")}
                    data-testid="mobile-sidebar-menu-container"
                >
                    <div className={"w-full h-full relative px-6 z-0 overflow-y-auto"}>
                        <div className={"pb-24"}>
                            {/* Header stuff section */}
                            <div className={"w-full flex flex-row justify-between items-center py-4"}>
                                <p className={`${s.title} ${highContrast ? "highTitleFirst" : ""}`}>
                                    Filtrar e organizar
                                </p>
                                <button
                                    type={"button"}
                                    id={"mobile-sidebar-close-button"}
                                    className={"flex flex-row items-center justify-center"}
                                    onClick={() => handleMenu()}
                                    data-testid="mobile-sidebar-close-button"
                                >
                                    <img
                                        src={iconCategoryClose}
                                        className={s.closeIcon}
                                        alt={"Close icon"}
                                    />
                                </button>
                            </div>
                            {/* Actual form section */}
                            {form}
                        </div>
                        <div className={s.filterButtonContainer + (isOpen ? ` ${s.isOpen}` : "")}>
                            <button
                                type={"button"}
                                className={s.filterButton}
                                onClick={() => dispatchSyncEvent()}
                            >
                                Filtrar
                            </button>
                        </div>
                    </div>
                </div>

                {/* Backdrop element */}
                <div className={s.backdrop + (isOpen ? ` ${s.openBackdrop}` : "")} />
            </div>
        </Fragment>
    )
}

export default MobileSidebar;
